import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";
import { StripeProductFormComponent } from "../components/create-stripe-product/StripeProductFormComponent";
import { AdminSettingsFormComponent } from "../components/admin-settings/AdminSettingsFormComponent";

function AdminSettings() {
  return (
    <Container maxWidth={"lg"} fixed>
      <SecureArea memberPermission={MemberPermission.SuperAdmin}>
        <Typography variant="h4" color="primary" gutterBottom>
        Edit Admin Settings
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
        Fill out the form to update the admin settings
        </Typography>
        <Box mt={4}>
          {<AdminSettingsFormComponent id={null} /> }
        </Box>
      </SecureArea>
    </Container>
  );
}

export default withAITracking(reactPlugin, AdminSettings, "AdminSettings");
